<template>
  <div class="wrapper">
  <table class="table table-condensed table-hover">
    <thead>
      <tr>
        <th class="text-center"><i class="fa fa-flag"></i></th>
        <th>Product</th>
        <th>Codenames</th>
        <th>Merchant</th>
        <th>Purchase Date</th>
        <th>Enabled</th>
        <th>Manage</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="usage_right in usageRights">
        <tr v-bind:class="{'table-warning': !usage_right.enabled}">
          <td class="text-center">
            <product-offer-icon v-bind:icon="usage_right.product_offer.icon" height="36px"></product-offer-icon>
          </td>

          <td>
            <product-offer-item v-bind:productOffer="usage_right.product_offer"/> <br/>
            <sale-option v-bind:codename="parseSaleOptionCodename(usage_right)" v-bind:duration="usage_right.transaction.sale_option_duration"/>
          </td>

          <td>
            {{usage_right.product_offer.codename}} <br/>
            <div class="small text-muted">{{usage_right.transaction.inapp_product_id}}</div>
          </td>

          <td>
            <merchant v-bind:merchant="usage_right.transaction.merchant"></merchant>
          </td>

          <td>
            {{usage_right.start_date | moment("LLL")}}
            <div class="small text-muted" v-if="usage_right.end_date">Expires in {{usage_right.end_date | moment("LLL")}}</div>
          </td>

          <td>
            <label class="switch switch-default switch-primary">
              <input type="checkbox" class="switch-input" v-model="usage_right.enabled" @click="toggle(usage_right.id)">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </td>

          <td>
            <dropdown-button text="Actions" group="usage_rights">
              <div slot="dropdown-menu">
                <a class="dropdown-item" v-on:click.prevent="openDestroyModal(usage_right)" href="#">
                  <i class="fa fa-trash"></i>Destroy
                </a>

                <a class="dropdown-item" v-on:click.prevent="openJSONModal(usage_right)" href="#">
                  <i class="fa fa-code"></i>View JSON
                </a>

                <a class="dropdown-item" v-on:click.prevent="openMigrateModal(usage_right)" href="#">
                  <i class="fa fa-exchange"></i>Migrate
                </a>

                <!-- Trials -->
                <div v-if="isTrial(usage_right)">
                  <a class="dropdown-item" v-on:click.prevent="expireNow(usage_right)" href="#">
                    <i class="fa fa-calendar-minus-o"></i>Expire now
                  </a>
                  <a class="dropdown-item" v-on:click.prevent="expireOneWeek(usage_right)" href="#">
                    <i class="fa fa-calendar-check-o"></i>Expire in 7 days
                  </a>
                </div>

              </div>
            </dropdown-button>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</div>
</template>

<script>
import Modal from 'vue-strap/src/Modal'
import Moment from 'moment'

import ProductOfferItem from 'components/ProductOfferItem'
import ProductOfferIcon from 'components/ProductOfferIcon'
import DropdownButton from 'components/DropdownButton'
import Merchant from 'components/Merchant'
import SaleOption from 'components/SaleOption'

import Devices from 'services/devices'
import {EventBus} from 'services/eventBus'
import UsageRights from 'services/usageRights'

export default {
  name: 'device-usage-rights',
  props: ['device'],
  data () {
    return {
      usageRights: [],
      selectedUsageRight: null,
      destroyModal: false
    }
  },
  components: {
    ProductOfferItem,
    ProductOfferIcon,
    Merchant,
    SaleOption,
    Modal,
    DropdownButton
  },
  created () {
    this.getUsageRights()

    EventBus.$on('update-usage-rights', event => {
      this.updateUsageRights()
    })

    EventBus.$on('get-usage-rights', setter => {
      setter(this.usageRights)
    })
  },
  methods: {
    toggle (usageRightID) {
      Devices.toggleUsageRight(this, this.device.id, usageRightID)
        .then(response => {
          this.updateUsageRights()
        })
    },
    destroy (usageRightID) {
      Devices.destroyUsageRight(this, this.device.id, usageRightID)
        .then(response => {
          this.updateUsageRights()
        })
    },
    updateUsageRights () {
      this.getUsageRights()
      this.$emit('bump-revision')
    },
    getUsageRights () {
      Devices.usageRights(this, this.device.id).then(response => {
        this.usageRights = response.body.data
        EventBus.$emit('load-usage-rights', this.usageRights)
      })
    },
    openDestroyModal (usageRight) {
      this.selectedUsageRight = usageRight
      EventBus.$emit('destroy-modal', {
        name: usageRight.product_offer.codename,
        confirm: this.confirmDestroy
      })
    },
    openJSONModal (usageRight) {
      EventBus.$emit('json-modal', {
        title: 'Usage Right JSON',
        content: JSON.stringify(usageRight, null, 2)
      })
    },
    confirmDestroy () {
      this.destroy(this.selectedUsageRight.id)
      this.selectedUsageRight = null
    },
    parseSaleOptionCodename (usageRight) {
      return UsageRights.parseSaleOptionCodename(usageRight)
    },
    isTrial (usageRight) {
      return usageRight.end_date !== null
    },
    expire (usageRight, endDate) {
      Devices.expireUsageRight(this, this.device.id, usageRight.id, endDate.toISOString())
        .then(response => {
          this.getUsageRights()
          this.$emit('bump-revision')
          EventBus.$emit('alert-modal', {
            title: 'Success!',
            message: 'End date is ' + Moment(endDate).format('LLL')
          })
        })
    },
    expireNow (usageRight) {
      var now = new Date()
      this.expire(usageRight, now)
    },
    expireOneWeek (usageRight) {
      var oneWeek = new Date()
      oneWeek.setDate(oneWeek.getDate() + 7)
      this.expire(usageRight, oneWeek)
    },
    openMigrateModal (usageRight) {
      EventBus.$emit('migrate-usageright-modal', {
        usageRight: usageRight
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/DeviceUsageRights.vue